import { useLocalSearchParams } from 'expo-router'

import { AcceptScheduledTournamentScreen } from '@/screens/accept-scheduled-tournament'

export default function () {
  const { hash } = useLocalSearchParams<{ hash: string }>()

  return <AcceptScheduledTournamentScreen hash={hash ?? ''} />
}
